import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { SessionCallComponent } from './components/session-call/session-call.component';
import { ClientComponent } from './components/client/client.component';
import { HostComponent } from './components/host/host.component';

const routes: Routes = [


  //to je za test
  { path: 'test', pathMatch: 'full', component: HomeComponent },
  //to je za test
  { path: 'session-call/:room', component: SessionCallComponent },

  
  //začetna stran za NAI, z funkcijo SMSov
  { path: 'host', pathMatch: 'full', component: HostComponent },
  //začetna stran za NAI, z funkcijo SMSov
  { path: 'host/:room/:id', pathMatch: 'full', component: HostComponent },
  //stranka
  { path: ':room', pathMatch: 'full', component: ClientComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
